import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function CabifyChoose({ data }) {
  return (
    <>
      <section className="cabify-choose-area">
        <img src={data && data.backImage} alt="vector" className="img-responsive cabify-choose-vec" loading="lazy" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="cabify-choose-head">
                <h2 className="heading center-heading">{data && data.titlepart1} <span className="gradiant-color">{data && data.titlepart2}</span> {data && data.titlepart3}</h2>
                <p className="sub-heading">{data && data.description}</p>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <div className="cabify-choose-content">
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer1}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer2}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer3}</label>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="cabify-choose-content">
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer4}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer5}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer6}</label>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="cabify-choose-content">
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer7}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer8}</label>
                    </div>
                    <div>
                      <span><FontAwesomeIcon icon={faCheck} /></span>
                      <label>{data && data.pointer9}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="cabify-choose-image">
                <img src={data && data.image} alt="cabify-choose" className="img-responsive" loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
